// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__1YM_c","title":"styles_title__Fkv2W","fullScreen":"styles_fullScreen__oKUGn"};